import app from '@/main'

async function messageTranslate ({ senderId, receiverId, messageId, targetLanguageCode }) {
  return await app.wsp.sendRequest({
    data: {
      senderId: senderId,
      receiverId: receiverId,
      messageId: messageId,
      targetLanguageCode: targetLanguageCode // На какой язык нужно перевести
    },
    method: 'message.translate'
  })
}

export default messageTranslate